import React, { useState } from "react";
import { PlayIcon } from "lucide-react";
export type Tutorial = {
  id: string;
  title: string;
  description: string;
};
type TutorialLibraryProps = {
  tutorials: readonly Tutorial[];
  label: string;
};
function TutorialLibrary({
  tutorials,
  label
}: TutorialLibraryProps) {
  const [active, setActive] = useState<Tutorial>(tutorials[0]);
  return <div data-id="element-215" data-mp="2s2vbf2kcst3w">
      <div className="overflow-hidden rounded-2xl border border-pfpc-navy/15 bg-pfpc-navy" data-id="element-216" data-mp="2s33rf3brwejb">
        <div className="flex flex-col gap-1 border-b border-pfpc-offwhite/10 px-5 py-4 text-pfpc-offwhite sm:flex-row sm:items-center sm:justify-between" data-id="element-217" data-mp="2x1yfoksievat">
          <h2 className="font-heading text-xl font-extrabold" data-id="element-218" data-mp="2icit7h00hc0x">{active.title}</h2>
          <span className="text-[12px] font-semibold text-pfpc-offwhite/55" data-id="element-219" data-mp="2nb3l8t540pea">{label}</span>
        </div>
        <div className="relative aspect-video bg-[#0f1d2b]" data-id="element-220" data-mp="3b0xul0q7zvts">
          <iframe key={active.id} src={`https://www.youtube-nocookie.com/embed/${active.id}?rel=0`} title={`${active.title} video tutorial`} className="absolute inset-0 h-full w-full border-0" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-221" data-mp="3fs66c3f0vta4" />
        </div>
      </div>

      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-222" data-mp="30eb3wrounu3k">
        {tutorials.map((tutorial, index) => {
        const selected = tutorial.id === active.id;
        return <button key={tutorial.id} type="button" onClick={() => setActive(tutorial)} aria-pressed={selected} className={`flex min-h-[190px] flex-col items-start rounded-xl border p-5 text-left transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pfpc-orange ${selected ? "border-pfpc-navy bg-pfpc-navy text-pfpc-offwhite" : "border-pfpc-navy/15 bg-pfpc-offwhite text-pfpc-navy hover:border-pfpc-orange"}`} data-id="element-223" data-mp="3a55to61b1btr" data-mpi={index}>
              <span className={`grid h-9 w-9 place-items-center rounded-[10px] text-[12px] font-extrabold ${selected ? "bg-pfpc-orange text-pfpc-navy" : "bg-[#e3e7e5] text-pfpc-navy"}`} data-id="element-224" data-mp="3ttozkmx4eq32">{index + 1}</span>
              <span className="mt-5 font-heading text-[16px] font-extrabold leading-5" data-id="element-225" data-mp="7mgvrp1umr95">{tutorial.title}</span>
              <span className={`mt-2 text-[13px] leading-5 ${selected ? "text-pfpc-offwhite/68" : "text-pfpc-navy/62"}`} data-id="element-226" data-mp="boc1d5qtbqsq">{tutorial.description}</span>
              <span className="mt-auto inline-flex items-center gap-2 pt-4 text-[12px] font-bold uppercase tracking-[.08em]" data-id="element-227" data-mp="glc53a06whgo"><PlayIcon className="h-3.5 w-3.5" fill="currentColor" data-id="element-228" data-mp="lfyitjtqum3x" /> Watch video</span>
            </button>;
      })}
      </div>
    </div>;
}
export { TutorialLibrary };